import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import CircularProgress from '@mui/material/CircularProgress';

const useStyles = makeStyles(() => ({
  waitingOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.4)',
  },
}));

const WaitingOverlay = () => {
  const classes = useStyles();
  return (
    <Box
      className={classes.waitingOverlay}
      display="flex"
      alignItems="center"
      justifyContent="flex-end"
      px={3}
    >
      <CircularProgress size={16} />
    </Box>
  );
};

const GroupSelector = (props) => {
  const {
    groups,
    loading,
    selectedGroupId,
    label,
    className,
    onSelectGroup,
  } = props;

  const handleSelectGroup = useCallback(
    (event) => {
      onSelectGroup(event.target.value);
    },
    [onSelectGroup]
  );

  return (
    <Box position="relative">
      <FormControl fullWidth className={className} disabled={loading}>
        <InputLabel htmlFor="simple-select">{label}</InputLabel>
        <Select onChange={handleSelectGroup} value={selectedGroupId}>
          {groups.map((group) => (
            <MenuItem key={group._id} value={group._id}>
              {group.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {loading && <WaitingOverlay />}
    </Box>
  );
};

GroupSelector.propTypes = {
  className: PropTypes.string,
  groups: PropTypes.array,
  loading: PropTypes.bool,
  selectedGroupId: PropTypes.string,
  label: PropTypes.node,

  onSelectGroup: PropTypes.func,
};

GroupSelector.defaultProps = {
  className: undefined,
  groups: [],
  loading: false,
  selectedGroupId: '',
  label: <FormattedMessage id="groupSelector.label" />,

  onSelectGroup() {},
};

export default GroupSelector;
